import React from "react";

export default function Article(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12.243" height="15.304" viewBox="0 0 12.243 15.304">
			<path
				id="ic_description_24px"
				d="M11.652,2H5.53A1.528,1.528,0,0,0,4.008,3.53L4,15.773A1.528,1.528,0,0,0,5.523,17.3h9.19a1.535,1.535,0,0,0,1.53-1.53V6.591Zm1.53,12.243H7.061v-1.53h6.121Zm0-3.061H7.061V9.652h6.121Zm-2.3-3.826V3.148L15.1,7.356Z"
				transform="translate(-4 -2)"
				fill="#2d6fa7"
			/>
		</svg>
	);
}
